import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./styles.css";

function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setMenuOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setMenuOpen(false);
    }, 150); // Small delay to prevent menu from closing too quickly
  };

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setMenuOpen((open) => !open);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  // Click outside handler to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest('.menu-fab-wrapper')) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [menuOpen]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      className="menu-fab-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className="menu-fab"
        onClick={handleClick}
        aria-label="Open menu"
      >
        <span className="menu-fab-icon">☰</span>
      </button>
      {menuOpen && (
        <div 
          className="menu-dropdown"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Link
            to="/"
            className={location.pathname === "/" ? "menu-link active" : "menu-link"}
            onClick={handleLinkClick}
          >
            Home
          </Link>
          <Link
            to="/transit-security"
            className={location.pathname === "/transit-security" ? "menu-link active" : "menu-link"}
            onClick={handleLinkClick}
          >
            Transit Security
          </Link>
          <Link
            to="/dynamic-transit"
            className={location.pathname === "/dynamic-transit" ? "menu-link active" : "menu-link"}
            onClick={handleLinkClick}
          >
            Dynamic Transit Operations
          </Link>
          <Link
            to="/cybersecurity-glossary"
            className={location.pathname === "/cybersecurity-glossary" ? "menu-link active" : "menu-link"}
            onClick={handleLinkClick}
          >
            Foundational Project Glossary
          </Link>
          <Link
            to="/responsible-use"
            className={location.pathname === "/responsible-use" ? "menu-link active" : "menu-link"}
            onClick={handleLinkClick}
          >
            About
          </Link>
        </div>
      )}
    </div>
  );
}

export default Navbar; 